import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS, config } from './config';
import { ImportOnlineSlideFeature } from '@framework/workbench/ui/import-slide/import-online-slide/import-online-slide-feature';
import { INSERT_SLIDE_ORIGIN_TYPE } from '@src/js/constant';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { TitlebarFileMenuConfig, ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Controller({ menuItems: MENU_CONFIGS })
export class ImportOnlineSlideController {
    constructor(private readonly feature: ImportOnlineSlideFeature) {
    }

    @Menu(config.id, 'onClick')
    public exportNative() {
        const object = {
            TriggerFrom: INSERT_SLIDE_ORIGIN_TYPE.TOP,
        };
        this.feature.callback(object);
    }

    @Menu(config.id, 'shouldHide')
    public handleHide() {
        return !!(appConfigInstance.getConfig(TitlebarFileMenuConfig.simplifyMode as any) ?? false)
        || !(appConfigInstance.getConfig(ToolbarFileMenuConfig.importFile as any) ?? true);
    }
}
